import { Injectable } from '@angular/core';

@Injectable()
export class FormatterService {

  constructor() { }

    getDataFormatter(){
        return '2018-04-03'
    }
}



// WEBPACK FOOTER //
// ./src/app/resources-modules/formatter/formatter.service.ts